<template>
    <CCard>
        <CCardBody>
            <v-toolbar flat color="white">
                <v-toolbar-title>مغایرت گیری موجودی انبار</v-toolbar-title>
                <v-spacer></v-spacer>




                <v-dialog v-model="productOptionBarCodes" max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">اطلاعات بارکد زیر محصول</span>
                        </v-card-title>
                        <v-card-text>

                                    <v-data-table
                                            :headers="productOptionsBarCodesHeaders"
                                            :items="selectedProductOptionBarCodes.list"
                                            :hide-default-footer="true"
                                            :disable-pagination="true"
                                            class="elevation-1">
                                        <template v-slot:item="{item}">
                                            <tr>
                                                <td>{{ item.barcode }}</td>
                                                <td>{{ item.input_id }}</td>
                                                <td>{{ item.inventory_code === null ? 'نامشخص' : item.inventory_code
                                                    }}
                                                </td>
                                                <td>{{ item.floor_code === null ? 'نامشخص' : item.floor_code }}</td>
                                                <td>{{ item.shelf_code === null ? 'نامشخص' : item.shelf_code }}</td>
                                                <td>{{ item.unit_price }}</td>
                                            </tr>
                                        </template>
                                    </v-data-table>

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <label>تعداد: {{ selectedProductOptionBarCodes.count }}</label>
                            <v-spacer></v-spacer>
                            <label>جمع قیمت: {{ selectedProductOptionBarCodes.sum | currency('', 0, { symbolOnLeft: false }) }} ریال</label>
                            <v-spacer></v-spacer>
                            <CButton color="info" class="mb-2 ml-2 text-white"
                                    @click="goToBlankRoute('/report/inventoryentrylog/po' + selectedProductOptionId)">
                                اقلام وارد و خارج شده از انبار
                            </CButton>                            
                            
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="productOptionBarCodes = false">
                                بستن
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>     


                <v-dialog v-model="inputOutputDialog" max-width="800px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">ورودی و خروجی از انبار</span>
                        </v-card-title>
                        <v-card-text>
                            

                                    <v-data-table
                                            :headers="inputOutputHeaders"
                                            :items="selectedInputOutputList.list"
                                            :footer-props="{
                                                        'items-per-page-options': [100,25, 50]
                                            }"
                                            :options.sync="inputOutputOptions"
                                            class="elevation-1">
                                        <template v-slot:item="{item}">
                                            <tr>
                                                <td>{{ item.id }}</td>
                                                <td>{{ item.qty }}</td>
                                                <td>{{ item.barcode_qty }}</td>
                                                <td>{{ item.is_input === '0' ? 'خروجی' : 'ورودی'}}</td>
                                                <td>{{ item.cat_name }}</td>
                                                <td>{{ item.bill_id === null ? 'نامشخص' : item.bill_id }}</td>
                                                <td>{{ item.invoice_id === null ? 'نامشخص' : item.invoice_id }}</td>
                                                <td>{{ convertDateToJDate(item.set_date) }}</td>
                                            </tr>
                                        </template>
                                    </v-data-table>

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="inputOutputDialog = false">
                                بستن
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog> 

                <v-dialog v-model="isMessageDialog" max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">اطلاعات</span>
                        </v-card-title>
                        <v-card-text>

                                    {{ messageDialog }}

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="isMessageDialog = false">
                                بستن
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog> 

            </v-toolbar>
            <CCard>
                <CCardHeader >
                    <CIcon name="cil-justify-center"/>
                    <strong> فیلتر </strong>
                </CCardHeader>                
                <CCardBody>
                    <CRow>
                        <CCol sm="3">
                            <CInput
                                    label="مدل کالا"
                                    v-model="filters.model"
                            />
                        </CCol>
                        <CCol sm="3">
                            <CInput
                                    label="شناسه فاکتور خرید"
                                    v-model="filters.bill_id"
                            />
                        </CCol>        
                        <CCol sm="3">
                            <CInput
                                    label="شناسه فاکتور فروش"
                                    v-model="filters.invoice_id"
                            />
                        </CCol>           
                        <CCol sm="3">
                            <div role="group" class="form-check">                                
                                <input id="uid-y91q5azm44p" type="checkbox" v-model="filters.barcode_count_discrepancy" class="form-check-input" value="1">
                                <label for="uid-y91q5azm44p" class="form-check-label">تعداد بارکد با تعداد موجودی یکی نباشد.</label>
                            </div>
                            <div role="group" class="form-check">                                
                                <input id="uid-y91q5azm44d" type="checkbox" v-model="filters.site_qty_qty_discrepancy" class="form-check-input" value="0">
                                <label for="uid-y91q5azm44d" class="form-check-label">تعداد موجودی با سایت یکی نباشد.</label>
                            </div>                            
                        </CCol>  

                    </CRow>
                </CCardBody>
                <CCardFooter class="text-left">
                    <CButton size="sm" color="info" class="text-white" v-if="loading === true" style="margin-left:10px;">
                                لطفا منتظر بمانید ...
                    </CButton>                    
                    
                    <CButton size="sm" color="primary" class="text-white" @click="applyFilters">
                        <CIcon name="cil-check-circle"/>
                        اعمال
                    </CButton>
                    
                    <CButton size="sm" color="danger" class="text-white mr-1" @click="resetFilters">
                        <CIcon name="cil-ban"/>
                        حذف فیلتر ها
                    </CButton>
                </CCardFooter>
            
            </CCard>
            <CCollapse :show="collapse" :duration="400">
                <CRow class="text-left" dir="ltr">
                    <CButton color="primary" class="mb-2 ml-2 text-white" @click="syncERPToSiteAll()" dir="rtl" >
                        انتقال تعداد از ERP به سایت
                    </CButton>
                    <CButton color="info" class="mb-2 ml-2 text-white"                         
                            @click="selectAll()" >
                        انتخاب همه
                    </CButton>                      
                </CRow>

                <v-data-table
                    :headers="headers"
                    :items="revenues"
                    :server-items-length="revenuesCount"
                    :footer-props="{
                                'items-per-page-options': [100,25, 50]
                    }"
                    :options.sync="revenuesOptions"
                    sort-by="barcode_count"
                    sort-desc
                    class="elevation-1">                

                    <template v-slot:item="{item}">
                        <tr>
                            <td class="custom-checkbox">                                                
                                <CInputCheckbox :checked.sync="item.selected" value="1" />                                
                            </td>                            
                            <td>{{ item.model }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.tags_name }}</td>    
                            <td>                                
                                <CButton size="sm" color="info" class="text-white" @click="onProductOptionBarCodesDialogOpen(item)">
                                    {{ item.barcode_count }}
                                </CButton>                              
                            </td>
                            <td>
                                <CButton size="sm" color="info" class="text-white" @click="openInputOutputDialog(item)">
                                    {{ item.qty }}
                                </CButton>                                 
                            </td>
                            <td>
                                <CButton size="sm" color="info" class="text-white" @click="openSiteQtyDetail(item)">
                                    {{ item.site_qty }}
                                </CButton>                                       
                            </td>
                            <td>{{ item.diff_qty }}</td>   
                            <td>{{ item.sync_date === null ? 'نامشخص' : convertDateToJDate(item.sync_date) }}</td>                               
                            <td>{{ item.sync_user }}</td>                  
                            <td style="padding-top: 10px;padding-bottom: 10px;">

                                
                                <CButton size="sm" color="info" class="text-white" @click="syncSiteToERP(item)" v-if="false">
                                    انتقال تعداد از سایت به ERP
                                </CButton>

                                <CButton size="sm" color="warning" class="text-white" @click="syncInputQtyWithBarcode(item)" v-if="false">
                                    اصلاح موجودی ERP براساس بارکد
                                </CButton>                   

                                <CButton size="sm" color="warning" class="text-white" @click="makeSiteQtyZero(item)" >
                                    صفر کردن موجودی سایت
                                </CButton> 

                                <br /><br />                                             
                                
                                <CButton size="sm" color="success" class="text-white" @click="syncERPToSite(item)" >
                                    انتقال تعداد از ERP به سایت
                                </CButton>

                                <br /><br />                                             
                                
                                <CButton size="sm" color="danger" class="text-white" @click="syncERPToSiteWithPrompt(item)" >
                                    تغییر دستی تعداد سایت
                                </CButton>                                

                                <v-spacer></v-spacer>                              
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </CCollapse>
        </CCardBody>
    </CCard>
</template>

<script>
    import {functionAction, getCategoryType, getFunction, uploadFile, getProductOptionDetails, callWebservice} from '../../webservice/webservice';
    import {iconsSet} from '../../assets/icons/icons'
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
    import moment from "moment-jalaali";

    export default {
        name: 'InventoryDiscrepancy',
        props: {},
        iconsSet,
        components: {
            datePicker: VuePersianDatetimePicker
        },
        methods: {
            selectAll(){
                
                this.isSelectAll = !this.isSelectAll;
                //alert(this.isSelectAll);
                for (let i = 0; i < this.revenues.length; i++) {
                    var newValue = this.revenues[i];
                    newValue.selected = this.isSelectAll;
                    this.$set(this.revenues, i, newValue)
                }
                
                //console.log(this.invoices);
            },               
            getObjectNameById(list, key, id, extraKey) {
                for (let i = 0; i < list.length; i++) {
                    console.log(list[i][key], id);
                    if (list[i][key] === id) {
                        if (extraKey) {
                            return list[i].name + ' ' + list[i][extraKey]
                        }
                        return list[i].name
                    }
                }
            },
            convertDateToJDate(dt) {
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD HH:mm');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },

            applyFilters() {
                let filters = Object.assign({}, this.filters);
                Object.keys(filters).forEach(function (key) {
                    if (filters[key] === '' || filters[key] === 0) {
                        delete filters[key]
                    }
                });
                this.options.page = 1;
                this.refreshRevenues(false);
                this.filteredReq = filters;
                this.collapse = true;
            },
            resetFilters() {
                this.filters = {};
                this.refreshRevenues(false);
                this.filteredReq = {}
            },

            refreshRevenues(afterAction) {
                let fileType = undefined;
                this.loading = true;
                let filters = Object.assign({}, this.filters);
                Object.keys(filters).forEach(function (key) {
                    if (filters[key] === '' || filters[key] === 0) {
                        delete filters[key]
                    }
                });
                if(afterAction){
                    filters['after_action'] = true;
                }
                getFunction(this.$http, 'quantity/getlist', 
                        ((this.revenuesOptions.page-1) * this.revenuesOptions.itemsPerPage),
                        this.revenuesOptions.itemsPerPage, 
                        (this.revenuesOptions['sortBy'] ? this.revenuesOptions['sortBy'][0] : ''), 
                        (this.revenuesOptions['sortDesc'] && this.revenuesOptions['sortDesc'][0]) ? 'desc' : 'asc', 


                      filters, 
                      fileType
                    ).then((resp) => {
 
                        this.revenues = resp.list;
                        this.revenuesCount = resp.count;
                        this.loading = false;
                    
                });
                this.filteredReq = filters;
            },
            showFile(attachment) {
                window.open('https://api.erp.masterkala.com/1.0.0/tools/images/' + attachment, '_blank');
            },
            onProductOptionBarCodesDialogOpen(item) {
                this.productOptionBarCodes = true;
                this.selectedProductOptionId = item.product_option_id;
                getProductOptionDetails(this.$http, item.product_option_id).then((resp) => {
                    this.selectedProductOptionBarCodes = resp
                });
            },
            syncSiteToERP(item) {
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {
                    let obj = {
                        "product_option_id": item.product_option_id,
                        "site_qty": item.site_qty,
                        "qty": item.qty
                    }

                    callWebservice(this.$http, 'quantity/syncsitetoerp',obj).then((resp) => {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        this.refreshRevenues();
                    }, (err) => {
                        this.errors = err.body.errors;
                        this.$toasted.show(err.body.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                    });                     
                }
            },
            syncInputQtyWithBarcode(item) {
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {
                    let obj = {
                        "product_option_id": item.product_option_id,
                        "barcode_count": item.barcode_count,
                        "qty": item.qty
                    }

                    callWebservice(this.$http, 'quantity/syncbarcodewithinputqty',obj).then((resp) => {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        this.refreshRevenues();
                    }, (err) => {
                        this.errors = err.body.errors;
                        this.$toasted.show(err.body.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                    });                         
                }
            },
            syncERPToSite(item) {
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {
                    let obj = {
                        "product_option_id": item.product_option_id,
                        "opencart_product_id": item.opencart_product_id,
                        "tags": item.tags,
                        "qty": item.qty,
                        "site_qty": item.site_qty
                    }

                    callWebservice(this.$http, 'quantity/syncerptosite',obj).then((resp) => {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        this.refreshRevenues(true);
                    }, (err) => {
                        this.errors = err.body.errors;
                        this.$toasted.show(err.body.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                    });                   
                }                
            },   
            syncERPToSiteWithPrompt(item) {
                let isValid = true;
                let customQty = prompt("لطفا تعداد سایت را وارد کنید.", item.site_qty);
                if (customQty == null) {
                    isValid = false;
                }

                if(isValid && parseInt(customQty) < parseInt(item.site_qty)){
                    alert("تعداد وارد شده نمیتواند از تعداد سایت کمتر باشد.");
                    isValid = false;
                }

                if(isValid && parseInt(customQty) > parseInt(item.qty)){
                    alert("تعداد وارد شده نمیتواند از تعداد erp بیشتر باشد.");
                    isValid = false;
                }                
                
                
                
                if (isValid) {
                    let obj = {
                        "product_option_id": item.product_option_id,
                        "opencart_product_id": item.opencart_product_id,
                        "tags": item.tags,
                        "qty": customQty,
                        "site_qty": item.site_qty
                    }

                    callWebservice(this.$http, 'quantity/syncerptosite',obj).then((resp) => {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        this.refreshRevenues(true);
                    }, (err) => {
                        this.errors = err.body.errors;
                        this.$toasted.show(err.body.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                    });                   
                }                
            },               
            makeSiteQtyZero(item) {
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {
                    let obj = {
                        "product_option_id": item.product_option_id,
                        "opencart_product_id": item.opencart_product_id,
                        "tags": item.tags,
                        "qty": item.qty,
                        "site_qty": item.site_qty,
                        "make_it_zero": "1"
                    }

                    callWebservice(this.$http, 'quantity/syncerptosite',obj).then((resp) => {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        this.refreshRevenues(true);
                    }, (err) => {
                        this.errors = err.body.errors;
                        this.$toasted.show(err.body.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                    });                   
                }                
            },   

            syncERPToSiteAll() {
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {

                    var selectedArr = [];
                    for(let o=0;o<this.revenues.length;o++){
                        var item = this.revenues[o];
                        if(item.selected){                            
                            let obj = {
                                "product_option_id": item.product_option_id,
                                "opencart_product_id": item.opencart_product_id,
                                "tags": item.tags,
                                "qty": item.qty,
                                "site_qty": item.site_qty
                            }                            
                            selectedArr.push(obj);
                        }
                    }
                    
                    if(selectedArr.length === 0){
                        this.$toasted.show("لطفا یک یا چند سطر انتخاب کنید.", {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                    }
                    else{
                        callWebservice(this.$http, 'quantity/syncerptosite_all',selectedArr).then((resp) => {
                            this.$toasted.show(resp.message, {
                                theme: "toasted-primary",
                                position: "bottom-center",
                                duration: 3000
                            });
                            this.refreshRevenues(true);
                        }, (err) => {
                            this.errors = err.body.errors;
                            this.$toasted.show(err.body.message, {
                                theme: "toasted-primary",
                                position: "bottom-center",
                                duration: 3000
                            });
                        });    
                    }               
                }                
            },                      
            goToBlankRoute(routeName) {
                let routeData = this.$base_url  + routeName;
                window.open(routeData, '_blank');
            },
            openInputOutputDialog(item){
                    this.selected_product_option_id = item.product_option_id;

                    let req = {
                        "start": 0,
                        "limit": 1000,
                        "sort": 'id',
                        "order": 'desc',
                        "filter": {'product_option_id':item.product_option_id}
                    };

                    callWebservice(this.$http, 'inputs/getinputandoutput',req).then((resp) => {
                        this.selectedInputOutputList = resp;
                        this.inputOutputDialog = true;
                    }, (err) => {
                        this.errors = err.body.errors;
                        this.$toasted.show(err.body.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                    });                   
            },
            openSiteQtyDetail(item){
                    let req = {
                        "opencart_product_id": item.opencart_product_id,
                        "tags": item.tags,
                    };

                    callWebservice(this.$http, 'quantity/getqtyorderinsite',req).then((resp) => {
                        this.messageDialog = resp.message;
                        this.isMessageDialog = true;
                    }, (err) => {
                        this.errors = err.body.errors;
                        this.$toasted.show(err.body.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                    });    

                    

            }
        },
        data: () => {
            return {
                dialog: false,
                headers: [
                    {text: 'انتخاب', value: 'select'},
                    {text: 'مدل', value: 'model'},
                    {text: 'نام کالا', value: 'name'},
                    {text: 'نام زیر محصول', value: 'tags'},              
                    {text: 'تعداد بارکد موجود', value: 'barcode_count'},
                    {text: 'تعداد موجودی ERP', value: 'qty'},
                    {text: 'تعداد سایت', value: 'site_qty', sortable: false},
                    {text: 'تعداد مغایرت', value: 'diff_qty', sortable: false},                          
                    {text: 'تاریخ آخرین سینک', value: 'sync_date', sortable: false},                    
                    {text: 'کاربر سینک کننده', value: 'sync_user', sortable: false},
                    {text: 'عملیات', value: 'actions', sortable: false}
                ],
                productOptionsBarCodesHeaders: [
                    {text: 'بارکد', value: 'barcode'},
                    {text: 'آیتم ورودی', value: 'input_id'},
                    {text: 'انبار', value: 'inventory_code'},
                    {text: 'طبقه', value: 'floor_code'},
                    {text: 'قفسه', value: 'shelf_code'},
                    {text: 'قیمت واحد', value: 'unit_price'}
                ],
                inputOutputHeaders : [
                    {text: 'شناسه', value: 'id'},
                    {text: 'تعداد', value: 'qty'},
                    {text: 'تعداد بارکد خورده', value: 'barcode_qty'},
                    {text: 'نوع', value: 'is_input'},
                    {text: 'دسته بندی', value: 'cat_name'},
                    {text: 'شناسه فاکتور خرید', value: 'bill_id'},
                    {text: 'شناسه فاکتور فروش', value: 'invoice_id'},
                    {text: 'زمان ثبت', value: 'set_date'}
                ],
                revenues: [],
                revenuesCount: 0,
                revenuesOptions:{},


                options: {},

                collapse: false,
                filters: {},

                tableOption: {
                    sortDesc: true,
                    sortedField: 'name',
                    itemsPerPage: 300,
                    page: 1
                },
                filteredReq: {},
                categories: {
                    accounts: [],
                    contacts: [],
                    bills: [],
                    invoices: []
                },
                money: {
                    decimal: '',
                    thousands: ',',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                },
                productOptionBarCodes: false,
                selectedProductOptionId: 0,
                selectedProductOptionBarCodes: [],   
                isSelectAll: false,
                inputOutputDialog: false,
                selectedInputOutputList: [],
                loading: false,
                selected_product_option_id:false,
                messageDialog: '',
                isMessageDialog: false,

            }
        },
        mounted() {
   
            
        },
        computed: {

        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            revenuesOptions: {
                handler(value) {
                    if(this.collapse){
                        console.log(this.revenuesOptions.page);
                        this.tableOption.sortedField = value['sortBy'][0];
                        this.tableOption.sortDesc = value['sortDesc'][0];
                        this.tableOption.itemsPerPage = value.itemsPerPage;
                        this.tableOption.page = value.page;
                        this.loading = true;

                        getFunction(this.$http, 'quantity/getlist', (value.itemsPerPage * (value.page-1)) ,
                            value.itemsPerPage,
                            value['sortBy'][0],
                            value['sortDesc'][0] ? 'desc' : 'asc',
                            this.filteredReq).then((resp) => {
                            this.revenues = resp.list;
                            this.revenuesCount = resp.count;
                            this.loading = false;
                        });
                    }
                },
                deep: true,
            },
            inputOutputOptions: {
                handler(value) {
                    
                        console.log(this.inputOutputOptions.page);

                        let req = {
                            "start": (value.itemsPerPage * (value.page-1)),
                            "limit": value.itemsPerPage,
                            "sort": value['sortBy'][0],
                            "order": value['sortDesc'][0] ? 'desc' : 'asc',
                            "filter": {'product_option_id':this.selected_product_option_id}
                        };

                        callWebservice(this.$http, 'inputs/getinputandoutput',req).then((resp) => {
                            this.selectedInputOutputList = resp;
                            this.inputOutputDialog = true;
                        }, (err) => {
                            this.errors = err.body.errors;
                            this.$toasted.show(err.body.message, {
                                theme: "toasted-primary",
                                position: "bottom-center",
                                duration: 3000
                            });
                        });                           
                    
                },
                deep: true,
            },            
        },
    }
</script>
